module.exports = __webpack_public_path__ + "media/images/vector-134@2x-8ee4b319014a437a8a84b072eb0ab751.png";